import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ParcelService {
  private apiUrl = `${environment.apiUrl}/parcels`;

  constructor(private http: HttpClient) { }

  // Get available parcels for repack with optional service code filter
  getAvailableParcelsForRepack(serviceCode?: string): Observable<any> {
    let params = new HttpParams();
    if (serviceCode) {
      params = params.append('serviceCode', serviceCode);
    }
    return this.http.get(`${this.apiUrl}/available-for-repack`, { params });
  }

  // Get parcel by tracking number
  getParcelByTrackingNumber(trackingNumber: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/${trackingNumber}`);
  }
}